import React, { FC, useEffect, useState, useContext } from 'react';
import { TasksContext, TasksDispatchContext, useTask } from '../stateManagement/context';
import Typography from "@material-ui/core/Typography";
import {IAssessment, IAssessmentTemplate, IAssessmentTemplateDetail} from "../types/types";
import {
    Accordion,
    AccordionSummary,
    Chip,
    Grid,
    Paper
} from "@material-ui/core";
import {get, post} from "../fetchers/fetchers";
import AdequacyDetails from "./adequacy_detail";
import {useParams} from "react-router";
import {ExpandMore} from "@material-ui/icons";
import {getProjectAssessments}  from "../stateManagement/data";
import { get_query } from '../stateManagement/data';

import { API_URL } from "../env";

interface IRouteParams {
    id: string
}

interface IEngInputsProps {
    initial_template_group_name: string,
    template_group_id:number

}

interface IGroupTemplate {
    template_name: string,
    template_id: number,
    templates: IAssessmentTemplateDetail[]
}



const AssessmentTemplates: FC<IEngInputsProps> = ({initial_template_group_name,template_group_id}: IEngInputsProps) => {

    let dispatch = useContext(TasksDispatchContext)
    let tasks = useTask()

    const [template_group_name] = useState<string>(initial_template_group_name);

    const [templateGroups, setTemplateGroups] = useState<IGroupTemplate[]>([]);

    const [assessments, setAssessments] = useState<IAssessment[]>([]);

    const params = useParams<IRouteParams>()


    useEffect(() => {

        if (tasks.loaded) {
            setAssessments(tasks.projectAssessments)             
            prepareAssessmentTemplates(tasks.assessmentTemplates )   
        }       
    }, [tasks])


    const renderSection = (index: number, group: IGroupTemplate) => {

        let initial_assessment = getInitialAssessment(group)

        let color = "#535353"
        let bcolor = "rgb(196,196,196)";
        let alpha = 1
        let level_text = "undefined"
        let adequacy = initial_assessment.assessment_template_detail?.adequacy

        if (adequacy) {
            if (adequacy.level === 1) {
                bcolor = "rgba(206,238,208," + alpha+ ")";
                color = "rgb(48,104,33)";
                level_text = adequacy.name;
            }
            if (adequacy.level === 2) {
                bcolor = "rgba(252,236,166," + alpha+ ")";
                color = "rgb(152,96,34)";
                level_text = adequacy.name;
            }
            if (adequacy.level === 3) {
                bcolor = "rgba(251,84,81," + alpha+ ")";
                color = "rgb(104,4,0)";
                level_text = adequacy.name;
            }
        }

        return (<Accordion style={{backgroundColor: "#f3f3f3"}} square>
            <AccordionSummary id={index.toString()} expandIcon={<ExpandMore/>}>

                <Typography variant="h6"> {group.template_name} </Typography>

                <div style={{marginLeft: "auto", marginRight: 0}}>
                    <Chip
                        size="small"
                        label={level_text}
                        color="primary"
                        style={{backgroundColor:bcolor, color:color}}
                    />
                </div>
            </AccordionSummary>
            <AdequacyDetails templates={group.templates} initialAssessment={
                initial_assessment} updateAssessment={setAssessment} template_id={group.template_id} template_group_id={template_group_id}/>
        </Accordion>)
    }


    const prepareAssessmentTemplates = (all_assessment_templates: IAssessmentTemplateDetail[]) => {

        let filtered_templates = all_assessment_templates.filter((t) => {
            return t.template.group.name === template_group_name
            
        })

        // Toplevel Groups and orde
        let topGroups = new Set<string>()
        filtered_templates.map(templateDetail => {
            topGroups.add(templateDetail.template.group.name)
        })

        // Generate Groups
        let groups = new Set<string>()
        let groups_array = new Array<IAssessmentTemplate>()
        filtered_templates.map(templateDetail => {
            if (!groups.has(templateDetail.template.name)) {
                groups_array.push(templateDetail.template)
            }
            groups.add(templateDetail.template.name)
            
        })

        // sort groups_array by order
        groups_array.sort((a, b) => {
            return a.display_order - b.display_order
        })

        // Generate Adequacy Levels
        let al = new Set<string>()
        filtered_templates.map(templateDetail => {
            al.add(templateDetail.adequacy.name)
        })

        let groupings: IGroupTemplate[] = []
        Array.from(groups_array).map(
            d => {
                groupings = [...groupings, {
                    template_name: d.name,
                    template_id: filtered_templates?.find(t => t.template.name === d.name)?.template.uuid as number,
                    templates: filtered_templates.filter(t => t.template.name === d.name)
                }]
            })
        setTemplateGroups(groupings)

    }

    const getInitialAssessment = (g: IGroupTemplate): IAssessment => {
        let assessment = assessments?.find(a => (a.assessment_template_detail?.template.uuid == g.template_id))

        if (assessment) {
            return assessment;

        }

        return {
            justification: "",
            assessment_template_detail_id: -1
        }
    }
    const setAssessment = async (assessment: IAssessment) => {

        // check if states in params
        let query_params = get_query()

        // check if state key in params
        if (query_params.state) {
            assessment["state_id"] = parseInt(query_params.state)
        }

        await post<IAssessment>(API_URL + "assessments/" + params.id + "/assessment", assessment);
        getProjectAssessments(params.id, dispatch);
    }

    return (

        <Grid container xs={12} lg={12} style={{padding: 10, width: "100%"}}>
            <Paper variant={"outlined"}
                   style={{display: "flex", flexDirection: "column", height: "100%", margin: "10px", flex: 1}}>
                {templateGroups.map((g, index) => {
                    return (<div>
                        {renderSection(index + 1, g)}
                    </div>)
                })}
            </Paper>
        </Grid>

    );
}

export default AssessmentTemplates;
